import { RequestorDetailsProps } from "../../types";
import { DateTimeUtil } from "../../utils";

const RequestorDetails: React.FC<RequestorDetailsProps> = ({
    requestor,
    requestorDetails,
    effectiveConsecutiveDays,
}) => {
    if (!requestor || !requestorDetails) return null;

    return (
        <div className="flex items-center p-4 border-b rounded-lg shadow-sm">
            {/* Avatar Section */}
            <div className="flex-shrink-0">
                <img
                    className="w-20 h-20 rounded-full border-2 border-gray-300 object-cover"
                    src={requestor.image_url || "/default-avatar.png"}
                    alt={requestor.name || "User Avatar"}
                />
            </div>

            {/* Details Section */}
            <div className="ml-2">
                <h3 className="text-xl font-semibold text-gray-700">{requestor.name || "N/A"}</h3>

                <div className="text-gray-600">
                    <p>
                        <span className="font-medium"></span> {requestorDetails.shift_name || "N/A"}
                    </p>
                    <p>
                        {requestorDetails.shift_start_date && requestorDetails.shift_end_date
                            ? DateTimeUtil.formatDateTimeRangeUtc(
                                  requestorDetails.shift_start_date,
                                  requestorDetails.shift_end_date
                              )
                            : "N/A"}
                        {effectiveConsecutiveDays && (
                            <span> + {effectiveConsecutiveDays} days</span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RequestorDetails;
